import {useEffect} from "react";
import {MapFeatures} from "@ui/leafletCustom/types";


export function useResizeMapByChangeDeps({
                                                  dependency,
                                                  mapFeatures,
                                              }: {
    mapFeatures: MapFeatures,
    dependency:unknown[]
}) {
    useEffect(() => {
        if (!mapFeatures) {
            return
        }
        mapFeatures?.invalidateSize()
    }, dependency);
}